import styled from '@emotion/styled';
import { Button } from '@ui-components/neo.tax';

import { KeywordSearch, Menu } from '@neo.tax/shared';

export const ButtonStyled = styled(Button)({
  margin: 0,
});

export const AddPayrollExpenseMenu = styled(Menu)({
  padding: '0 0 0.25rem 0',
  width: 320,
  zIndex: 100, // Without this, the menu is hidden behind the table
});

export const KeywordSearchStyled = styled(KeywordSearch)({
  boxShadow: 'none',
  '& input': {
    border: 0,
    boxShadow: 'none',
    ':focus': {
      boxShadow: 'none',
      outline: 'none',
    },
  },
});
